import { useContext } from 'react';

import { LayoutContext } from 'shared/legacy/contexts/LayoutContext/LayoutContext';
import { useStyles } from './SharedLayoutComponents.styles';

export const SharedLayoutComponents = () => {
  const { Snackbar } = useContext(LayoutContext);
  const classes = useStyles();

  return <div css={classes.root}>{Snackbar}</div>;
};
